import { State } from './types';

export const bannerStoreSelector = {
  isVisible: (state: State): State['isVisible'] => state.isVisible,
  item: (state: State): State['item'] => state.item,
  getItem: (state: State): State['getItem'] => state.getItem,
  close: (state: State): State['close'] => state.close,
};
